import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PortalService } from "src/app/services/portal/portal.service";
import { loadCatalogProducts, loadCatalogProductsFailed, loadCatalogProductsSuccess } from "../actions/catalog-products.actions";

@Injectable()
export class CatalogEffects {
	private actions$ = inject(Actions);
	private portalService = inject(PortalService);


	// Load the portal product catalog from backend blob storage
	loadCatalogProduct$ = createEffect(() => this.actions$.pipe(
		ofType(loadCatalogProducts),
		switchMap((action) =>
			this.portalService.getPortalCatalogProductsByType(action.productType).pipe(
				map(resp => loadCatalogProductsSuccess({ productType: action.productType, catalogProducts: resp.data })),
				catchError(async (error) => loadCatalogProductsFailed({ productType: action.productType, error: error }))
			)
		)
	));

}
